<osn-shared-icon-button
  [iconName]="'play'"
  [buttonText]="'Player_PlayNxtEpisode_In_X_Seconds_Btn' | translate: { seconds: inXSeconds }"
  data-testid="MoviePlayerPage.endOfPlayNextEpisodeButton"
></osn-shared-icon-button>
